import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { createAcademicLevel } from "../../services/school/academicLevel";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { AcademicLevelFormValidation } from "./AcademicLevelFormValidation";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { EnterIcon } from "@radix-ui/react-icons";
import { AcademicLevelType } from "../../types/AcademicLevelType";

export const CreateAcademicLevel = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: createAcademicLevel, mutationKey: "createAcademicLevel" });

    const { control, handleSubmit, formState: { errors } } = useForm<AcademicLevelType>({
        resolver: yupResolver(AcademicLevelFormValidation),
        defaultValues: {
            description: "",
            code: "",
            status: true,
        },
        mode: "onBlur",
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Nível Acadêmico criado!");
            navigate(routes.academicLevels);
        } catch (err) {
            toast.error("Erro ao criar Nível Acadêmico");
        }
    });

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent name="description" label="Nome" control={control} errors={errors} required={true} />
                    {/* <TextFieldComponent name="code" label="Código" control={control} errors={errors}/> */}
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="submit" disabled={mutation.isLoading} variant="surface">
                            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                            Registar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
